import { DateTime } from "luxon";
import { OpenReverificationRequest } from "shared/types";

export const shortenName = (fullName?: string | null) => {
  const parts = (fullName ?? "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1][0]}.`;
};

export const getReverificationApplicantName = (
  request: Pick<
    OpenReverificationRequest,
    "applicant_first_name" | "applicant_last_name"
  >
) =>
  shortenName(
    [request.applicant_first_name, request.applicant_last_name]
      .filter(Boolean)
      .join(" ")
  ) || "the applicant";

export const getReverificationTypeLabel = (
  type: OpenReverificationRequest["type"]
) => (type === "identity" ? "identity" : "income");

const formatShortDate = (iso: string) => {
  const date = DateTime.fromISO(iso);
  return date.isValid ? date.toFormat("LLL d") : "";
};

export const formatReverificationRequest = (
  request: OpenReverificationRequest
) => {
  const typeLabel = getReverificationTypeLabel(request.type);
  const date = formatShortDate(request.requested_at);
  const requester = shortenName(request.requested_by_name);

  return [
    `${typeLabel[0].toUpperCase()}${typeLabel.slice(1)} re-verification requested for ${getReverificationApplicantName(request)}`,
    date ? ` on ${date}` : "",
    requester ? ` by ${requester}` : ""
  ].join("");
};
